<template>
  <div class="row vehicle-selector">
    <div
      class="col-md-4 title"
    >
      <p>
        Fit your {{ modelTitle }}
      </p>
    </div>
    <div class="col-md-4">
      <select v-model="year">
        <option value="0" selected disabled>Year</option>
        <option :disabled="!showViewAllOption" value="0">View All</option>
        <option v-for="year of years" :key="year" :value="year">
          {{ year }}
        </option>
      </select>
    </div>
    <div class="col-md-4">
      <select v-model="bodyTypeId">
        <option value="0" selected disabled>Body Type</option>
        <option
          v-for="bodyType of bodyTypes"
          :key="bodyType.bodyTypeId"
          :value="bodyType.bodyTypeId"
        >
          {{ bodyType.title }}
        </option>
      </select>
    </div>
    <div v-show="isLoading" class="col-12 loading-wrapper">
        <img src="/cdn/images/loading.gif" width="50" />
    </div>
  </div>
</template>

<script>
export default {
  props: [  
      "manufacturerId", 
      "modelId",
      "modelTitle", 
      "data", 
      "label_is_this_your_vehicle", 
      "label_select_vehicle"
      ],
  data() {
    return {
      years: this.data.years,
      year: 0,
      selectedVehicle: null,
      vehicles: [],
      bodyTypes: [],
      bodyTypeId: 0,
      isLoading: false,
      vehiclesCount: 0,
      visibleVehiclesCount: 0,
    };
  },
  mounted() {
      this.vehiclesCount = document.querySelectorAll('li.vehicle').length;
  },
  methods: {
    selectVehicle() {
      this.$store.commit("solutions/setSelectedVehicle", this.selectedVehicle);
       window.location.href = `/${window.culture}/roof`;  
    },
  },
  computed: {
    apiVehicles() {
      return this.vehicles.map((vehicle) => {
        return vehicle.Vehicle.vehicleId;
      });
    },
    showViewAllOption() {
      return this.vehiclesCount > 1 && this.year != 0 && (this.vehiclesCount > this.visibleVehiclesCount);
    }
  },
  watch: {
    async year() {
      this.isLoading = true;

      this.bodyTypeId = 0;
      try {
        let url = `api/vehicle/model/body-types/${this.modelId}/${this.year}`;
        let response = await axios.get(url);
        this.bodyTypes = response.data.data;
        if (this.bodyTypes.length == 1) {
          this.bodyTypeId = this.bodyTypes[0].bodyTypeId;
        }
        this.isLoading = false;

      } catch (err) {
        this.isLoading = false;
      }
    },
    async bodyTypeId() {
      this.isLoading = true;
      try {
        const url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}`;

        let response = await axios.get(url);
        this.vehicles = response.data.data;
        if (this.vehicles.length == 1) {
          this.selectedVehicle = this.vehicles[0].Vehicle;
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    vehicles() {
      this.isLoading = false;

      let vehicles = document.querySelectorAll('li.vehicle');

      if (vehicles.length > 0) {
        this.visibleVehiclesCount = 0;
        for(let vehicle of vehicles) {
          vehicle.style.display = 'list-item';
          if (!this.apiVehicles.includes(vehicle.id) ) {
            vehicle.style.display = 'none';
          } else {
            this.visibleVehiclesCount = this.visibleVehiclesCount + 1;
          }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  select {
    margin-top: 1rem;
  }
  .title {
    display: flex; 
    align-items: center;
    text-align: center;
    @media screen and (max-width: 768px) {
      justify-content: center; 
    }
    p {
      text-transform:uppercase;
      display:flex;
      align-items: center;
      margin-bottom:0;
      font-family:'trim-regular';
      font-size:1.5rem;
      padding-top: 1rem;
      @media screen and (max-width: 992px) {
       font-size: 1rem;
      }
    }
  }
  .loading-wrapper {
    display:flex;
    justify-content:center;
    padding-top:1rem;
  }
</style>